(function ($) {
  'use strict';

  $(function () {
    $('.qld__media__video').on('click', function () {
      var $container = $(this);
      var $iframe = $container.find('iframe');
      var $video = $container.find('video');

      if ($iframe.length) {
        // Handle iframe embeds (YouTube, Vimeo, etc.)
        var src = $iframe.attr('src');
        if (src && src.indexOf('autoplay=1') === -1) {
          $iframe.attr('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        }
      } else if ($video.length) {
        // Handle local uploaded video files
        $video.get(0).play();
      }

      // Hide the thumbnail overlay
      $container.find('.qld__media__video-thumbnail').fadeOut();
    });
  });
})(jQuery);